import _extends from "@babel/runtime/helpers/extends";
import { compose } from '@beef/utils';
import React from 'react';
import { getWindow } from "../../../../../../../utils/window";
import { withOnScreenAnalytics } from "../../../../../../../utils/withOnScreenAnalytics";
import { ymPushParams } from "../../../../../../../utils/ym.alternative";
import { getAccountType } from "../../../../../../../utils/analytics";
import { Modal } from "./Modal";
import { getOnScreenAnalyticsHandler } from "./analytics";
export var QRModal = compose(withOnScreenAnalytics(getOnScreenAnalyticsHandler({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
}), {
  shouldTriggerOnce: true,
  debounce: 100
}))(function (props) {
  return /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    "data-t-id": "SBPModal-QRModal"
  }));
});